import { Card, CardContent } from "@/components/ui/card";
import { Brain, TrendingUp, Shield, BrainCircuit } from "lucide-react";
import { motion } from "framer-motion";
import ResponsiveImage from "@/components/ui/responsive-image";

const features = [
  {
    icon: Brain,
    title: "Backed by Behavioral Science",
    description: "Built on proven psychological principles that create lasting change—not just surface-level tips."
  },
  {
    icon: TrendingUp,
    title: "Bite-sized Wisdom",
    description: "Learn in minutes a day with daily insights that help you notice patterns and rewire your money mindset"
  },
  {
    icon: Shield,
    title: "Impulse Protection",
    description: "Smart nudges and browser-based interventions help you pause before clicking \"Add to Cart.\"",
    hasChrome: true
  },
  {
    icon: BrainCircuit,
    title: "Habit Building",
    description: "Turn small actions into long-term change with habit loops grounded in behavioral research."
  }
];

export default function Features() {
  return (
    <section className="py-16 px-4 bg-background">
      <div className="container max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold font-display text-[#2D3436] mb-4">
            Your Financial Mindfulness Companion
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <Card className="border-2 border-[#E5D5B7]/20">
                <CardContent className="p-6">
                  <div className="flex justify-between items-start mb-4">
                    <feature.icon className="w-12 h-12 text-[#FF7063]" />
                    {feature.hasChrome && (
                      <a 
                        href="https://chromewebstore.google.com/detail/impause/deofpffeelbbckhopgmkgapcogaicahn" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="hover:opacity-90 transition-opacity"
                      >
                        <picture>
                          <source 
                            srcSet="/images/optimized/Chrome_Web_store-320.webp" 
                            type="image/webp" 
                          />
                          <img 
                            src="/images/Chrome_Web_store.png" 
                            alt="Available in the Chrome Web Store" 
                            className="h-12 w-auto"
                            width={180} 
                            height={48}
                            loading="eager"
                          />
                        </picture>
                      </a>
                    )}
                  </div>
                  <h3 className="text-xl font-bold mb-2 text-[#2D3436]">{feature.title}</h3>
                  <p className="text-[#235D62]">{feature.description}</p>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}